var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64945 0.437467L15.7939 12.8125C15.8598 12.9265 15.8944 13.0558 15.8944 13.1875C15.8944 13.3191 15.8598 13.4484 15.794 13.5625C15.7281 13.6765 15.6335 13.7712 15.5194 13.837C15.4054 13.9028 15.2761 13.9375 15.1444 13.9375H0.85545C0.723799 13.9375 0.594468 13.9028 0.480456 13.837C0.366445 13.7712 0.271769 13.6765 0.205945 13.5625C0.140121 13.4484 0.105468 13.3191 0.105469 13.1875C0.10547 13.0558 0.140124 12.9265 0.20595 12.8125L7.35045 0.437467C7.41628 0.323461 7.51096 0.228791 7.62497 0.162971C7.73898 0.0971511 7.8683 0.0625 7.99995 0.0625C8.1316 0.0625 8.26092 0.0971511 8.37493 0.162971C8.48894 0.228791 8.58362 0.323461 8.64945 0.437467ZM2.15445 12.4375H13.8454L7.99995 2.31247L2.15445 12.4375ZM7.24995 10.1875H8.74995V11.6875H7.24995V10.1875ZM7.24995 4.93747H8.74995V8.68747H7.24995V4.93747Z",
    fill: "#E85008"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/cancelled.1ec40a2cd4c31daba27e3243c4deb54e.svg";
export { ForwardRef as ReactComponent };